import React, { useState, useEffect, useRef } from "react";
// import { useParams, Link } from "react-router-dom";
// import { Accordion } from 'react-bootstrap';

import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

import Modalgallery from "../../../components/modalReflec";

import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import { Link } from "react-router-dom";
import moment from "moment";
import LinesEllipsis from "react-lines-ellipsis";
// import banner from "../../../assets/img/banner-wasteHero.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import img002 from "../../../assets/img/hero_02.jpg";
import sorn from "../../../assets/img/icon/ss.png";
import img01 from "../../../assets/img/20-01-2568/1_0.jpg";
import img02 from "../../../assets/img/20-01-2568/2_0.jpg";
import img03 from "../../../assets/img/20-01-2568/3_0.jpg";
import img04 from "../../../assets/img/20-01-2568/4_0.jpg";
import img05 from "../../../assets/img/20-01-2568/5_0.jpg";
import img06 from "../../../assets/img/20-01-2568/6_0.jpg";
import img07 from "../../../assets/img/20-01-2568/7_0.jpg";
import img08 from "../../../assets/img/20-01-2568/8_0.jpg";
import img09 from "../../../assets/img/20-01-2568/9_0.jpg";
import img10 from "../../../assets/img/20-01-2568/10_0.jpg";
import img11 from "../../../assets/img/20-01-2568/11_0.jpg";
import img12 from "../../../assets/img/20-01-2568/12_0.jpg";
import img13 from "../../../assets/img/20-01-2568/13_0.jpg";
import img14 from "../../../assets/img/20-01-2568/14_0.jpg";
import img15 from "../../../assets/img/20-01-2568/15_0.jpg";
// import img02 from "../../../assets/img/hero_2.jpg";
// import img03 from "../../../assets/img/hero_3.jpg";
// import vector1 from "../../../assets/img/icon/vector_1.svg";
// import vector2 from "../../../assets/img/icon/vector_2.svg";
// import vector3 from "../../../assets/img/icon/vector_3.svg";
// import vector4 from "../../../assets/img/icon/vector_4.svg";
// import vector5 from "../../../assets/img/icon/vector_5.svg";
// import vector6 from "../../../assets/img/icon/Malaysia.svg";
import nimgBanner from "./../../../assets/img/03-2026/banner.jpg";
import pj1 from "./../../../assets/img/03-2026/pj1.png";
import pj2 from "./../../../assets/img/03-2026/pj2.png";
import pj3 from "./../../../assets/img/03-2026/pj3.png";
import pj4 from "./../../../assets/img/03-2026/pj4.png";
import nimg5 from "./../../../assets/img/02-2025/5_0.png";
import nimg6 from "./../../../assets/img/02-2025/6_0.png";
import nimg8 from "./../../../assets/img/02-2025/8_0.png";
import nimg9 from "./../../../assets/img/03-2025/9_0.png";
import nimg10 from "./../../../assets/img/02-2025/7_0.png";
import nimg11 from "./../../../assets/img/03-2025/11_0.png";

import nitems1 from "./../../../assets/img/04-2025/item1.png";
import nitems2 from "./../../../assets/img/04-2025/item2.png";
import nitems3 from "./../../../assets/img/04-2025/item3.png";

import nsornUp from "./../../../assets/img/icon/sorn-up.svg";

import pjs1 from "./../../../assets/img/03-2026/slide/01_Banner.jpg";
import pjs2 from "./../../../assets/img/03-2026/slide/02_Banner.jpg";
import pjs3 from "./../../../assets/img/03-2026/slide/03_Banner.jpg";
import pjs4 from "./../../../assets/img/03-2026/slide/04_Banner.jpg";
import pjs5 from "./../../../assets/img/03-2026/slide/05_Banner.jpg";
import pjs6 from "./../../../assets/img/03-2026/slide/06_Banner.jpg";
import pjs7 from "./../../../assets/img/03-2026/slide/07_Banner.jpg";
import pjs8 from "./../../../assets/img/03-2026/slide/08_Banner.jpg";
import pjs9 from "./../../../assets/img/03-2026/slide/09_Banner.jpg";
import pjs10 from "./../../../assets/img/03-2026/slide/10_Banner.jpg";

import backIcon from "./../../../assets/img/icon/back.svg";
import nextIcon from "./../../../assets/img/icon/sorn.svg";

import Loading from "../../../components/loading";
import { getData } from "../../../services/getService";

const ggal = [
  { src: img01 },
  { src: img02 },
  { src: img03 },
  { src: img04 },
  { src: img05 },
  { src: img06 },
  { src: img07 },
  { src: img08 },
  { src: img09 },
  { src: img10 },
  { src: img11 },
  { src: img12 },
  { src: img13 },
  { src: img14 },
  { src: img15 },
];

const videos = [
  {
    country: "Brunei Darussalam",
    school: "SR Pengiran Anak Puteri Besar",
    title: "1V+1F = Healthy Child: A Healthy Lunch Meal School Programme",
    youtubeId: "W3dhfErHS98",
  },
  {
    country: "Indonesia",
    school: "SD Negeri 2 Landasan Ulin Barat",
    title:
      "Healthy and Sustainable Lunch Programme: Investing in the Future of the Golden Generation",
    youtubeId: "mMgRZMhn6Mk",
  },
  {
    country: "Malaysia",
    school: "Sekolah Bimbingan Jalinan Kasih",
    title:
      "Health Heroes: Raising Awareness & Empowering Healthy Eating Habits",
    youtubeId: "a34Rb9xC1vg",
  },
  {
    country: "Malaysia",
    school: "SJK (C) Chung Hwa Tamparuli",
    title: "HEALTHY BITES: Small Changes for Big Health Benefits",
    youtubeId: "rZhouAT2mKo",
  },
  {
    country: "Philippines",
    school: "Patiis Elementary School",
    title:
      "Project SMILE: Sustainable Meal Plan that can Improve Nutritional Lifestyle of Every Batang Patiis",
    youtubeId: "8PhPDKG-GOI",
  },
  {
    country: "Thailand",
    school: "Ban Pangmahan School",
    title: "Promote Healthy Eating for Sustainable Good Health",
    youtubeId: "nElsjIZLTO8",
  },
  {
    country: "Thailand",
    school: "Aroyama Border Patrol Police School",
    title:
      "The Community School Collaboration Project Creating Products and Nutrition Values for One Health and SEP",
    youtubeId: "VTJhOBml64Y",
  },
];

const episodes = [
  { label: "EP.00", youtubeId: "dXgpAmrnCcU" },
  { label: "EP.01", youtubeId: "RfMlcxbVH0w" },
  { label: "EP.02", youtubeId: "huQbytQenoY" },
  { label: "EP.03", youtubeId: "-I1F1bxFDX0" },
  { label: "EP.04", youtubeId: "-aF7lAREzkE" },
  { label: "EP.05", youtubeId: "8QB2YKMAxL8" },
];

const sharingSessions = [
  {
    title:
      "From Challenges to Change: Webinar on School-Led Solutions for Student Health & Well-being",
    text: "9 October 2025",
    youtubeId: "loV_UWfBR10",
    episodes: null,
  },
  {
    title: "Online Sharing Session for Brunei Darussalam",
    text: "Learning from Experiences: 1V + 1F = Healthy Child: A Healthy Lunch Meal School Programme (11 November 2025) <br/>Co-hosted by Sekolah Rendah Pengiran Anak Puteri Besar",
    youtubeId: "5GRNqMZCLNA",
    episodes: null,
  },
  {
    title: "Online Sharing Session for Indonesia",
    text: "Success Story: Investing in Golden Generation - SD Negeri 2 Landasan Ulin Barat's Strategy to Change Nutritional Behaviour (13 November 2025) <br/>Co-hosted by SD Negeri 2 Landasan Ulin Barat",
    youtubeId: "LIrSmMtjwB8",
    episodes: null,
  },
  {
    title: "Online Sharing Session for Malaysia",
    text: "Learning from School-Led Solutions: Health Heroes and Healthy Bites (24 November 2025)<br/>Co-hosted by Sekolah Bimbingan Jalinan Kasih and SJK (C) Chung Hwa Tamparuli",
    youtubeId: "qCIHbrbGqPs",
    episodes: null,
  },
  {
    title: "Online Sharing Session for Philippines",
    text: "Healthy Meals, Happy Learners - Project SMILE” Sustainable Meal Plan to Improve Nutritional Lifestyle (12 December 2025) <br/>Co-hosted by Patiis Elementary School",
    youtubeId: "MOqJawVuUng",
    episodes: null,
  },
  {
    title: "On-site Sharing Session for Thailand",
    text: "From Soil to Plate: A Joint Learning Journey for Health and Sustainability, in Celebration of World Soil Day 2025 (4 December 2025) <br/>Co-hosted by Ban Pangmahan School and Aroyama Border Patrol Police School ",
    youtubeId: "dXgpAmrnCcU",
    episodes: episodes,
  },
];

const Main = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataOne, setDataOne] = useState({});
  const [dataS, setDataS] = useState(null);
  const [dataLimit, setDataLimit] = useState(3);

  const [mainData, setMainData] = useState(ggal);
  const [modalgallery, setModalgallery] = useState({ view: false });

  const slideImages = [
    pjs1,
    pjs2,
    pjs3,
    pjs4,
    pjs5,
    pjs6,
    pjs7,
    pjs8,
    pjs9,
    pjs10,
  ];

  const called = useRef(true);

  useEffect(() => {
    if (called.current) {
      Promise.all([fetchDataOne()]).then((res) => {
        setIsLoading(false);
      });
    }
    return () => {
      called.current = false;
    };
  }, []);

  const fetchDataOne = async () => {
    getData("pageawards", "promotion")
      .then((response) => {
        if (response.status === "success") {
          setDataOne(response.data);
        }
      })
      .catch((e) => {
        console.log(e.response.data.error);
      });
  };

  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
  };

  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", right: "-30px" }}
        onClick={onClick}
      >
        <img
          src={nextIcon}
          className="ms-2"
          style={{ width: "12px", marginTop: "-20px" }}
          alt=""
        />
      </div>
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", left: "-30px", zIndex: 1 }}
        onClick={onClick}
      >
        <img
          src={nextIcon}
          className="me-2"
          style={{
            transform: "rotate(180deg)",
            width: "12px",
            marginTop: "-20px",
          }}
          alt=""
        />
      </div>
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // แสดง 3 รูป
    slidesToScroll: 1, // เลื่อนทีละ 1 รูป
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "40px", // 👈 ทำให้เห็นรูปข้าง ๆ (ปรับได้)
          arrows: false,
        },
      },
    ],
  };

  console.log(mainData);

  return (
    <>
      <div id="outer-container" style={{}}>
        <Header page="activities" sub="partnership" />
        <div className="wrapper bg-white box-index">
          {isLoading ? <Loading /> : null}
          <section className="pb-md-5 bg-top">
            <div className="container-fluid">
              <div className="row justify-content-center pb-md-5 text-start">
                <div className="col-12 col-md-12 col-lg-12 p-0">
                  <div className="">
                    <img
                      src={
                        process.env.REACT_APP_IMG_LINK +
                        "/uploads/awards/" +
                        dataOne.id +
                        "/" +
                        dataOne.img
                      }
                      className="w-100 rounded"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-9 mt-3 mt-md-4">
                  <div className="font-50 weight-700">{dataOne.topic}</div>
                  <div className="mb-5 pt-3">
                    <div
                      className="font-18 text-justify content-custom"
                      dangerouslySetInnerHTML={{
                        __html: dataOne.detail,
                      }}
                    />

                    {/* <div >
                                            <div className="sub-topic weight-700 mt-3">About the Organisers</div>
                                            <p style={{ fontWeight: "bold" }}><b>SEAMEO SEPS</b></p>
                                            <p style={{ textAlign: "justify" }}>SEAMEO Regional Centre for Sufficiency Economy Philosophy for Sustainability (SEAMEO SEPS) was established as one of the 26 SEAMEO Regional Centres under the Southeast Asian Ministers of Education Organization (SEAMEO). SEAMEO SEPS was established in 2019 and hosted by the Ministry of Education of Thailand, with its aims to promote the philosophy, principles and values of the Sufficiency Economy as an instrument for achieving Sustainable Development Goals (SDGs) among 11 Southeast Asian Countries, namely, Brunei Darussalam, Cambodia, Indonesia, Lao PDR, Malaysia, Myanmar, Philippines, Singapore, Thailand, Timor-Leste, and Vietnam. </p>
                                            <p style={{ fontWeight: "bold" }}><br /></p>
                                            <p style={{ fontWeight: "bold" }}><b><a href="https://www.seaohun.org" target="_blank">SEAOHUN</a></b></p>
                                            <p style={{ textAlign: "justify" }}>The Southeast Asia One Health University Network (SEAOHUN), established in 2011, is an academic and research network promoting the One Health concept. Comprising over 100 educational institutions from eight ASEAN countries, SEAOHUN builds professional capacity to address complex One Health issues, conducts research for evidence-based decision-making, and assists governments with public health surge capacity. The SEAOHUN Secretariat is located in Mueang district, Chiang Mai, Thailand.</p>
                                            <p style={{ fontWeight: "bold" }}><br /></p>
                                            <p style={{ fontWeight: "bold" }}><b><a href="https://www.chevron.com" target="_blank">CHEVRON</a></b></p>
                                            <p style={{ textAlign: "justify" }}>Chevron is one of the world’s leading integrated energy companies. As a company of problem solvers, we look to the future of energy with optimism. We provide affordable, reliable, and ever-cleaner energy to people in the Eurasia Pacific region that is essential to achieving a more prosperous and sustainable world. We invest in community programmes that help advance the UN’s sustainable development goals and strive to empower people to meet their full potential. </p>
                                        </div> */}
                  </div>
                </div>
              </div>
              <div
                className="row justify-content-center py-3 py-md-5 text-start"
                style={{ background: "#FFDE59" }}
              >
                <div className="col-11 col-md-9 col-lg-9">
                  <div>
                    <div>
                      <img src={nimgBanner} className="w-100" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center pb-md-5 mt-md-5">
                <div className="col-12 col-md-12 col-lg-12 text-center">
                  <div className="sub-topic weight-700 mt-3">
                    About Organisers
                  </div>
                  <div className="row justify-content-center">
                    <div className="col-4 col-md-2 col-lg-2 text-end">
                      <a href="https://www.chevron.com" target={"_blank"}>
                        <img
                          src={nitems1}
                          className="w-75 pt-md-4 ps-3 ps-md-5"
                        />
                      </a>
                    </div>
                    <div className="col-4 col-md-2 col-lg-2">
                      <a href="https://www.seaohun.org" target={"_blank"}>
                        <img src={nitems2} className="w-100 pt-3 pt-md-5" />
                      </a>
                    </div>
                    <div className="col-4 col-md-2 col-lg-2">
                      <a
                        href="https://seameoseps.org/about/whoweare"
                        target={"_blank"}
                      >
                        <img
                          src={nitems3}
                          className="w-100 p-2 p-md-4 pt-md-5"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center text-start">
                <div className="col-11 col-md-9 col-lg-9">
                  <hr style={{ borderTop: "2px solid rgb(230, 193, 47)" }} />
                  <div className="pt-md-5 mt-5 ">
                    <div className="row justify-content-center text-start">
                      <div className="col-6 col-md-3 col-lg-3">
                        <button
                          className="btn text-center"
                          onClick={(e) => setDataS(1)}
                        >
                          <img src={nimg5} className="w-75 px-4" />
                          <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                            Objectives
                          </h4>
                        </button>
                      </div>
                      <div className="col-6 col-md-3 col-lg-3">
                        <button
                          className="btn text-center"
                          onClick={(e) => setDataS(2)}
                        >
                          <img src={nimg6} className="w-75 px-4" />
                          <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                            Participants
                          </h4>
                        </button>
                      </div>
                      <div className="col-6 col-md-3 col-lg-3">
                        <a
                          href="https://drive.google.com/file/d/1EzIQY2Ds87O36EhVmX3a1iXmQrA-oiQe/view?usp=sharing"
                          target={"_blank"}
                          className="btn text-center"
                        >
                          <img src={nimg10} className="w-75 px-4" />
                          <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                            Activities
                          </h4>
                        </a>
                      </div>
                      <div className="col-6 col-md-3 col-lg-3">
                        <a
                          href="https://drive.google.com/drive/folders/1GW6RWROi8EGBQ_EVZ3ls1CKNFme-iawe?usp=sharing"
                          target={"_blank"}
                          className="btn text-center"
                        >
                          <img src={nimg8} className="w-75 px-4" />
                          <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                            Documents
                          </h4>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="d-none d-md-block">
                      <div
                        className="row text-start"
                        style={{ marginBottom: "-20px" }}
                      >
                        <div className="col-12 col-md-3 col-lg-3 text-center">
                          {dataS === 1 && (
                            <img
                              src={nsornUp}
                              className=""
                              style={{
                                width: "50px",
                                filter:
                                  "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)",
                              }}
                            />
                          )}
                        </div>
                        <div className="col-12 col-md-3 col-lg-3 text-center">
                          {dataS === 2 && (
                            <img
                              src={nsornUp}
                              className=""
                              style={{
                                width: "50px",
                                filter:
                                  "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    {dataS === 1 ? (
                      <div
                        className="p-4 text-justify"
                        style={{ background: "#FFDE59", borderRadius: "15px" }}
                      >
                        <div>
                          <b>
                            The overarching objectives of the programme are as
                            follows:
                          </b>
                        </div>
                        <ul>
                          <li>
                            <b>Facilitate the exchange of information</b> on the
                            ‘One Health’ initiative and regional 'School
                            Well-being' practices among Southeast Asian
                            countries,
                          </li>
                          <li>
                            <b>Build knowledge and understanding</b> on 'One
                            Health' and input the ‘Sufficiency Economy
                            Philosophy (SEP)’ and ‘Sustainability’ concept to
                            drive the development of regional models for ‘School
                            Well-being’, focusing on best practices for school
                            meal improvement,
                          </li>
                          <li>
                            <b>Empower</b> school leaders, teachers, students,
                            together with surrounding communities through
                            capacity development programmes adopting a whole
                            school approach for improving school meal programme
                            that contribute to school well-being,
                          </li>
                          <li>
                            <b>
                              Develop a network for sharing best practices and
                              creative ideas
                            </b>{" "}
                            to support the continuous development of school
                            initiatives, and
                          </li>
                          <li>
                            <b>Identify model schools</b> from the participating
                            schools to inspire others in their respective
                            countries and the region.
                          </li>
                        </ul>
                      </div>
                    ) : dataS === 2 ? (
                      <div
                        className="p-4 text-justify"
                        style={{ background: "#FFDE59", borderRadius: "15px" }}
                      >
                        {/* <div><b>The overarching objectives of the programme are as follows:</b></div> */}
                        <p>
                          A total 185 educators including 29 school leaders and
                          156 teachers and non-teaching staff from 29 nominated
                          public primary schools, and 23 Ministry Coordinators
                          and Experts from 6 Southeast Asian countries, namely
                          Brunei Darussalam, Cambodia, Indonesia, Malaysia,
                          Philippines, and Thailand, have participated in the
                          programme.
                        </p>
                        <a
                          href="https://drive.google.com/file/d/1THv8i7cpuSwrsjDQ5mlMl2qVzekDeAxn/view?usp=sharing"
                          target={"_blank"}
                        >
                          List of Nominated Schools
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="row justify-content-center py-3 py-md-3 text-start">
                <div className="col-11 col-md-9 col-lg-9">
                  <div className="row text-start mt-5 justify-content-center align-items-stretch">
                    {/* กล่องซ้าย: วิดีโอพื้นหลังสีดำสูงเท่ากล่องขวา */}
                    <div className="col-12 col-md-7 col-lg-7 mb-3 mb-md-0">
                      <div
                        className="w-100 h-100"
                        style={{ background: "#000" }}
                      >
                        <iframe
                          className="w-100 h-100"
                          src={`https://www.youtube.com/embed/Jnkx5h_7rIA?si=Q7mkPLcvn94tH8SJ`}
                          title="Project Summary: Promotion of Well-being in Schools in Southeast Asia"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                        />
                      </div>
                    </div>

                    {/* กล่องขวา: รูปภาพ + ปุ่ม */}
                    <div className="col-12 col-md-5 col-lg-5">
                      <div className="h-100 d-flex flex-column justify-content-center">
                        <div>
                          <img src={pj1} className="w-100" alt="" />
                        </div>
                        <div className="text-center mt-3">
                          <a
                            href="https://drive.google.com/file/d/1-y4xgEmS-YqX1y2lPZfoUHt8TsGl2LsU/view?usp=sharing"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-green-passtel px-5 py-1 font-18 mt-2 mt-md-0 ms-md-4"
                          >
                            Download Project Report
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row text-start mt-5 justify-content-center">
                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                      <div>
                        <img src={pj2} className="w-100" alt="" />
                      </div>
                      <div className="text-center mt-3">
                        <a
                          href="https://drive.google.com/file/d/1L7PTyXkpdn3KNDOlMx4e6h6KYzA-GncR/view?usp=drive_link "
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-green-passtel px-5 py-1 font-18 mt-2 mt-md-0 ms-md-4"
                        >
                          Download Project Leaflet A4
                        </a>
                      </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                      <div>
                        <img src={pj3} className="w-100" alt="" />
                      </div>
                      <div className="text-center mt-3">
                        <a
                          href="https://drive.google.com/file/d/1s1vtEZmNdnlsaLIEoG845piYz8yPC99I/view?usp=drive_link "
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-green-passtel px-5 py-1 font-18 mt-2 mt-md-0 ms-md-4"
                        >
                          Download Poster 1
                        </a>
                      </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                      <div>
                        <img src={pj4} className="w-100" alt="" />
                      </div>
                      <div className="text-center mt-3">
                        <a
                          href="https://drive.google.com/file/d/153lMSvegSbFPVwAp6wlQSXZAB9dWOjle/view?usp=drive_link"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-green-passtel px-5 py-1 font-18 mt-2 mt-md-0 ms-md-4"
                        >
                          Download Poster 2
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="row justify-content-center py-3 py-md-5 text-start"
                style={{ background: "#7BBEF6" }}
              >
                <div className="col-11 col-md-9 col-lg-9">
                  <div className="sub-topic weight-700 mb-3 mb-4">
                    Country Spotlights
                  </div>
                  <div className="sscustom">
                    <Slider {...settings}>
                      {slideImages.map((img, index) => (
                        <div key={index}>
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setModalgallery({
                                view: true,
                                gallery: slideImages.map((src) => ({ src })), // 🔥 สำคัญ
                                dataUrl: img,
                                active: index,
                              })
                            }
                          >
                            <img src={img} className="w-100" alt="" />
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              </div>
              {/* <div className="row justify-content-center py-3 py-md-3 text-start">
                                <div className="col-11 col-md-9 col-lg-9"> 
                                    <div className="row text-start mt-5 justify-content-center">
                                     
                                            <div className="col-12 col-md-6 col-lg-6" >
                                                <div className="mb-2 ratio ratio-16x9">
                                                    <iframe
                                                        src={`https://www.youtube.com/embed/EdFTe7SHLd0`}
                                                        title="Promotion of Well-being in School in Southeast Asia Programme"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    />
                                                </div>                                               
                                            </div>
                                    </div>
                                </div>
                            </div> */}
              <div className="row justify-content-center py-3 py-md-3 text-start">
                <div className="col-11 col-md-9 col-lg-9">
                  <div className="sub-topic weight-700 mb-3">
                    Schools’ Achievements
                  </div>

                  <div className="row text-start mt-5">
                    {videos.map((item, index) => (
                      <div className="col-12 col-md-4 col-lg-4" key={index}>
                        <div className=" mb-2 ratio ratio-16x9">
                          <iframe
                            src={`https://www.youtube.com/embed/${item.youtubeId}`}
                            title={item.title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                          />
                        </div>
                        <div className="mb-4">
                          <b>{item.country}</b>
                          <br />
                          <b>{item.school}</b>
                          <br />
                          {item.title}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="row justify-content-center py-3 py-md-3 text-start">
                <div className="col-11 col-md-9 col-lg-9">
                  <div className="sub-topic weight-700 mb-3">
                    Sharing Sessions
                    <a
                      href="https://drive.google.com/file/d/1rgipBhBHZbvqjG8tTIgt-_pZYj11LoOg/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-green-passtel px-5 py-1 font-18 mt-2 mt-md-0 ms-md-4"
                    >
                      Concept Note
                    </a>
                  </div>

                  <div className="row text-start mt-5">
                    {sharingSessions.map((item, index) => (
                      <div className="col-12 col-md-4 col-lg-4" key={index}>
                        {item.youtubeId && (
                          <div className=" mb-2 ratio ratio-16x9">
                            <iframe
                              src={`https://www.youtube.com/embed/${item.youtubeId}`}
                              title={item.title}
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              allowFullScreen
                            />
                          </div>
                        )}

                        <div className="mb-4">
                          <p>
                            <b>{item.title}</b>
                          </p>
                          <div
                            className=""
                            dangerouslySetInnerHTML={{
                              __html: item.text,
                            }}
                          />
                          <div className="ep-list">
                            {item.episodes &&
                              item.episodes.map((ep, index) => (
                                <span key={ep.label}>
                                  <a
                                    href={`https://youtu.be/${ep.youtubeId}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="ep-link"
                                  >
                                    {ep.label}
                                  </a>
                                  {index < episodes.length - 1 && " | "}
                                </span>
                              ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="row justify-content-center pb-md-3 text-start">
                <div className="col-11 col-md-9 col-lg-9">
                  {dataOne.news && dataOne.news.length ? (
                    <div>
                      <div className="topic mb-4 ">News</div>
                      <div className="row">
                        {/* {dataNews.length ? dataNews.sort((a, b) => new Date(b.dateActive) - new Date(a.dateActive)).map((val, index) => ( */}
                        {dataOne.news
                          .sort(
                            (a, b) =>
                              new Date(b.dateActive) - new Date(a.dateActive)
                          )
                          .slice(0, dataLimit)
                          .map((val, index) => (
                            <div
                              className="col-12 col-md-4 col-lg-4"
                              key={index}
                            >
                              <Link
                                to={"/newsandgallery/news/" + val.newsId}
                                className="a-news pb-4 mb-4 mb-md-5"
                              >
                                <div className="row text-start">
                                  <div className="col-12 col-md-12 col-lg-12">
                                    <div>
                                      <img
                                        src={
                                          process.env.REACT_APP_IMG_LINK +
                                          "/uploads/news/" +
                                          val.newsId +
                                          "/" +
                                          val.banner
                                        }
                                        alt=""
                                        className="w-100 rounded"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-12 col-lg-12">
                                    <div className="font-14 mt-2">
                                      {moment(val.dateActive).format(
                                        "D MMMM Y"
                                      )}
                                    </div>

                                    <div
                                      className="news-topic mt-3 mt-md-0"
                                      dangerouslySetInnerHTML={{
                                        __html: val.topic,
                                      }}
                                    />
                                    {/* <div className="mt-1">
                                                                    <TagView myString={val.tag} />
                                                                </div> */}
                                    <div className="mt-4">
                                      <LinesEllipsis
                                        text={val.subTopic}
                                        maxLine="3"
                                        ellipsis="..."
                                        trimRight
                                        basedOn="letters"
                                      />
                                    </div>
                                    <div className="mt-3">
                                      <span style={{ color: "#e6c12f" }}>
                                        Read More
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          ))}
                      </div>
                      {/* <div className="text-center mb-5">
                                                {dataLimit === 9 ?
                                                    <btn className="btn btn-watch-passtel font-16 px-5" onClick={e => setDataLimit(3)}>Less</btn>
                                                    :
                                                    <btn className="btn btn-watch-passtel font-16 px-5" onClick={e => setDataLimit(9)}>More</btn>
                                                }
                                            </div> */}
                    </div>
                  ) : null}
                </div>
              </div>
              <div
                className="row justify-content-center py-3 py-md-5 text-start"
                style={{ background: "#FFDE59" }}
              >
                <div className="col-11 col-md-9 col-lg-9">
                  <div>
                    <div className="sub-topic weight-700 mb-3">Reflections</div>
                    <div className="banner-custom-b">
                      <AliceCarousel
                        mouseTracking
                        autoPlay
                        autoPlayInterval={4000}
                        animationDuration={2000}
                        animationType="slide"
                        touchTracking={false}
                        infinite
                        handleDragStart
                        controlsStrategy="alternate"
                        disableDotsControls
                        responsive={responsive}
                        renderPrevButton={() => {
                          return (
                            <p className="position-absolute">
                              <img
                                src={sorn}
                                className="sorn-left"
                                style={{ height: "40px" }}
                              />
                            </p>
                          );
                        }}
                        renderNextButton={() => {
                          return (
                            <p className="position-absolute end-0">
                              <img
                                src={sorn}
                                className="sorn-right"
                                style={{ height: "40px" }}
                              />
                            </p>
                          );
                        }}
                      >
                        {mainData.map((val, index) => (
                          <>
                            <img
                              src={val.src}
                              alt=""
                              key={index}
                              className="w-100 p-2"
                              onClick={() =>
                                setModalgallery({
                                  view: true,
                                  gallery: mainData,
                                  dataUrl: val.src,
                                  active: index,
                                })
                              }
                            />
                          </>
                        ))}
                      </AliceCarousel>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center py-3 py-md-5 text-start">
                <div className="col-11 col-md-9 col-lg-9">
                  <div className="sub-topic weight-700 mb-3">
                    Phase 1 Training Series{" "}
                    <a
                      href="https://drive.google.com/file/d/1cjN1FE5BQHm5pN0voserI85ZAC9CTqEX/view?usp=sharing"
                      target="_blank"
                      className="btn btn-green-passtel px-5 py-1 font-18 mt-2 mt-md-0 ms-md-4"
                    >
                      Concept Note
                    </a>
                    {/* <a style={{ textDecoration: "none", color: "unset" }} href="https://drive.google.com/file/d/1cjN1FE5BQHm5pN0voserI85ZAC9CTqEX/view?usp=sharing" target={"_blank"} className="sub-topic weight-700 mb-3">Phase 1 Training Series</a> */}
                  </div>
                  <div className="font-18">
                    Online Capacity Building Workshop Series on “Improvement of
                    School Lunch/ Feeding Programme”
                  </div>
                  <div>
                    <div className="row text-start mt-5">
                      <div className="col-12 col-md-4 col-lg-4">
                        <div className="mb-4 ratio ratio-16x9">
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/JwN_NkELtBI?si=FiiYWWWLbHgF-AdE"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-4">
                        <div className="mb-4 ratio ratio-16x9">
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/R3AjYeMP7VA?si=45OzWmQmaRmWWahR"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-4">
                        <div className="mb-4 ratio ratio-16x9">
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/uYAibLASk6Y?si=Af2X_3Z7yf264VAK"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 col-lg-3">
                        <div className="mb-4 ratio ratio-16x9">
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/JbeRWy_KNpY?si=gpoBEAXubVFWHoSs"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 col-lg-3">
                        <div className="mb-4 ratio ratio-16x9">
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/HwOx6xM8vho?si=oU60rIKQUW046gim"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 col-lg-3">
                        <div className="mb-4 ratio ratio-16x9">
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/5l7g5Ro1xTU?si=jM5zz4D4zBaGYBMP"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 col-lg-3">
                        <div className="mb-4 ratio ratio-16x9">
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/jDOWoDABNGI?si=QnTXuYUjT2rY8U92"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center pb-3 pb-md-3 text-start">
                <div className="col-11 col-md-9 col-lg-9">
                  <div className="sub-topic weight-700 mb-3">
                    Phase 2 Training Series
                    <a
                      href="https://drive.google.com/file/d/1yUwzeHZKxMTMOOtdkeYNYc4TrtFlER-L/view?usp=drive_link"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-green-passtel px-5 py-1 font-18 mt-2 mt-md-0 ms-md-4"
                    >
                      Concept Note
                    </a>
                  </div>
                  <div className="font-18">
                    In addition to the Phase 1 Training Series, 4 sessions of
                    Online Training were organised by highlighting the practical
                    ideas or techniques which the participating schools will be
                    able to apply to their school meal improvement activities
                    and overall school well-being.{" "}
                  </div>
                  <div>
                    <div className="row text-start mt-5">
                      <div className="col-12 col-md-3 col-lg-3">
                        <div className="mb-4 ratio ratio-16x9">
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/vtrPycLzde8?si=c-L6iKrW0sMa92Ei"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 col-lg-3">
                        <div className="mb-4 ratio ratio-16x9">
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/SDTHC-oSPQA?si=a0mlQSt0UwNcAlI4"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 col-lg-3">
                        <div className="mb-4 ratio ratio-16x9">
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/3HkO0YuTnBw?si=K5f_pBvuf2OQlZoc"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 col-lg-3">
                        <div className="mb-4 ratio ratio-16x9">
                          <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/NygdctJFtB8?si=AqrndrSqatV_BoHP"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <Footer page="activities" sub="partnership" />
        </div>
      </div>

      {modalgallery.view ? (
        <Modalgallery
          show={modalgallery.view}
          onHide={() => setModalgallery({ view: false })}
          dataUrl={modalgallery.dataUrl}
          folder={"news"}
          gallery={modalgallery.gallery}
          active={modalgallery.active}
          id={0}
        />
      ) : null}
    </>
  );
};

export default Main;
